import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const IMAGES = [
  {
    src: "https://static.prod-images.emergentagent.com/jobs/89f2f8d9-74f4-4335-b690-b9a815d801c5/images/29a394c6ebac1293f3df48f8711b0e12b2dbb9b14c818612a289626a5e4e2fbe.png",
    alt: "Commercial strip-out floor, London",
    tag: "Strip-Out · E1",
  },
  {
    src: "https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Modern commercial office interior",
    tag: "Fit-Out · E14",
  },
  {
    src: "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Residential kitchen refurbishment",
    tag: "Residential · RM10",
  },
  {
    src: "https://images.pexels.com/photos/380769/pexels-photo-380769.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Office interior with partition and ceiling works",
    tag: "Partitions · EC2",
  },
  {
    src: "https://images.pexels.com/photos/5974377/pexels-photo-5974377.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Active construction site in London",
    tag: "Site Works · N1",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/89f2f8d9-74f4-4335-b690-b9a815d801c5/images/afc55b94e53cdaea07cc484a6c8586ef990891aaaf3c7324f9dbe441c8163b0f.png",
    alt: "Contractor reviewing plans on site",
    tag: "Site Management",
  },
];

export default function ProjectGallery() {
  return (
    <section
      id="gallery"
      data-testid="project-gallery-section"
      className="bg-white text-[#2B2420] py-20 md:py-28 border-t border-[#E5DDD0]"
    >
      <div className="px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-4 font-bold">
              <span className="brand-gold-divider" /> Project Gallery
            </div>
            <h2
              className="font-black tracking-tighter leading-[0.95] text-3xl sm:text-4xl md:text-5xl"
              style={{ fontFamily: "Cabinet Grotesk" }}
            >
              A glimpse of recent works.
            </h2>
          </div>
          <a
            href="#quote"
            data-testid="project-gallery-cta"
            className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.15em] text-[#2B2420] hover:text-[#B8732C] transition-colors"
          >
            Start your project <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {IMAGES.map((img, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="img-zoom-wrap relative aspect-[4/3] overflow-hidden bg-[#E8E0D2] group"
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2B2420]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white bg-[#2B2420]/70 px-2 py-1">
                  {img.tag}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
